<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9354_80778)">
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint0_linear_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint1_radial_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint2_radial_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint3_linear_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint4_linear_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint5_linear_9354_80778)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint6_linear_9354_80778)"
      />
      <path d="M17.5888 7.75363C18.2532 8.01937 18.6889 8.66288 18.6889 9.37848V22.3785C18.6889 23.345 17.9054 24.1285 16.9389 24.1285C15.9724 24.1285 15.1889 23.345 15.1889 22.3785V13.9814C15.1889 13.8993 15.0886 13.8591 15.032 13.9187C14.3655 14.6186 13.2577 14.6457 12.5578 13.9791C11.8579 13.3126 11.8308 12.2049 12.4973 11.505L15.6716 8.17166C16.1651 7.65343 16.9244 7.48788 17.5888 7.75363Z"
            fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9354_80778"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BB3FD" />
        <stop offset="1"
              stop-color="#5194EC"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9354_80778"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_9354_80778"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_9354_80778"
                      x1="30"
                      y1="16"
                      x2="25.5"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9354_80778"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.13"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9354_80778"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9354_80778"
                      x1="29.9012"
                      y1="15.7489"
                      x2="2.27791"
                      y2="15.7489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <clipPath id="clip0_9354_80778">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>